export class DateHelper{

    public static today(date: Date = new Date()): Date{
        const startDate = new Date();
        startDate.setDate(date.getDate());
        startDate.setHours(0, 0, 0, 0);
        return startDate;
    }

    public static sevenDays(date: Date = new Date()): Date{
        const startDate = new Date();
        startDate.setDate(date.getDate() + 8);
        startDate.setHours(0, 0, 0, 0);
        return startDate;
    }

    public static tenDays(date: Date = new Date()): Date{
        const startDate = new Date();
        startDate.setDate(date.getDate() + 10);
        startDate.setHours(0, 0, 0, 0);
        return startDate;
    }

    public static fourteenDays(date: Date = new Date()): Date{
        const startDate = new Date();
        startDate.setDate(date.getDate() + 15);
        startDate.setHours(0, 0, 0, 0);
        return startDate;
    }

    public static twentyDays(date: Date = new Date()): Date{
        const startDate = new Date();
        startDate.setDate(date.getDate() + 20);
        startDate.setHours(0, 0, 0, 0);
        return startDate;
    }

    public static startOfWeek(date: Date = new Date()): Date{
        const startDate = new Date();
        startDate.setDate(date.getDate() - ((date.getDay() + 6) % 7));
        startDate.setHours(0, 0, 0, 0);
        return startDate;
    }

    public static endOfWeek(date: Date = new Date()): Date{
        const startDate = new Date();
        startDate.setDate(date.getDate() + (7 - date.getDay()) % 7);
        startDate.setHours(0, 0, 0, 0);
        return startDate;
    }

    public static startOfNextWeek(date: Date = new Date()): Date{
        const startDate = new Date();
        startDate.setDate(date.getDate() + (7 - date.getDay()) % 7 + 1);
        startDate.setHours(0, 0, 0, 0);
        return startDate;
    } 

    public static endOfNextWeek(date: Date = new Date()): Date{
        const startDate = new Date();
        startDate.setDate(date.getDate() + (14 - date.getDay()) % 14 + 1);
        startDate.setHours(0, 0, 0, 0);
        return startDate;
    }

    public static toString(date: Date): string{
        var d = date.getDate()
                    .toString()
                    .padStart(2, '0');
        var m = (date.getMonth() + 1)
                    .toString()
                    .padStart(2, '0'); // take care of the month's number here ⚠️
        var y = date.getFullYear();
        return y+'-'+m+'-'+d;
    }

    public static toDate(dateString: string): Date{
        return new Date(dateString);
    }

    public static getAge(birthDate: Date): number{
        var timeDiff = Math.abs(Date.now() - new Date(birthDate).getTime());
        return Math.floor(timeDiff / (1000 * 3600 * 24) / 365.25);
    }
}